import React, { createContext } from "react";
import { node, shape, string } from "prop-types";
import { ELEMENT_MESSAGE_TYPES as TYPES, ELEMENT_MESSAGE_THEMES as THEMES } from "#library/components/ElementMessage/misc/constants";
export var defaultValue = {
  type: TYPES.REGULAR,
  theme: THEMES.MESSAGE
};
export var ThemeContext = /*#__PURE__*/createContext();
export var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
    _ref$initialValue = _ref.initialValue,
    initialValue = _ref$initialValue === void 0 ? defaultValue : _ref$initialValue;
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: initialValue
  }, children);
};
ThemeProvider.propTypes = {
  children: node.isRequired,
  initialValue: shape({
    type: string.isRequired,
    theme: string.isRequired
  }).isRequired
};